export const colors = [
  "#F7BA46",
  "#FF4668",
  "#FE7445",
  "#466FFF",
  "#FE47CB",
  "#2BCE26",
  "#BFA2DB",
  "#BFB051",
  "#EEC4C4",
];

export const titles = {
  total: "total_contact",
  total_1_day: "new_contacts_today",
  total_7_day: "new_contacts_7_days",
  total_30_day: "new_contacts_30_days",
};

export const contactType = [
  {
    id: `contactType-0`,
    value: "",
    name: "all",
  },
  {
    id: `contactType-1`,
    value: "1",
    name: "vendor",
  },
  {
    id: `contactType-2`,
    value: "2",
    name: "employee",
  },
  {
    id: `contactType-3`,
    value: "3",
    name: "customer",
  },
  {
    id: `contactType-4`,
    value: "4",
    name: "other",
  },
];

// `salutations` kini diambil dari /WA/inits (Redux: salutationsSelector),
// bukan lagi hardcode di sini.

// Tipe channel tempat kontak punya identitas (App\Enum\WA\ChannelType di BE).
// Dipakai untuk filter `channel_types[]` daftar kontak dan field
// `channel_types` di detail kontak.
export const contactChannelTypes = {
  whatsapp: 1,
  inhouse: 4,
};

// Apakah channel boleh dipakai untuk mengirim pesan ke kontak berdasarkan
// channel_types kontak. Channel WA hanya untuk kontak bertipe WhatsApp, channel
// inhouse (tanpa waba_id) untuk kontak bertipe Inhouse. Belum ada info channel
// inhouse spesifiknya, jadi semua channel inhouse diizinkan. Kalau BE belum
// mengirim channel_types, semua channel diizinkan seperti sebelumnya.
export const isChannelAllowedForContact = (phoneNumber, channelTypes) => {
  if (!Array.isArray(channelTypes)) return true;
  return channelTypes.includes(
    phoneNumber?.waba_id
      ? contactChannelTypes.whatsapp
      : contactChannelTypes.inhouse
  );
};
